export default "__VITE_ASSET__d239f90d__"